import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { toast } from "react-toastify";
import { useLoading } from "../../../hooks/useLoading";
import InstallmentCheckBoxes from "../InstallmentCheckBoxes";
import commonNetwork from "../../../common/api/commonNetwork"
import RadioButtons from "../Elements/RadioButtons";
import { Checkbox, Input, Selector } from "../Elements";
import { getExpireDateById, paymentLinkDates } from "../../../constants/options/linkExpireDates";
import { getSendOptionById, sendOptions } from "../../../constants/options/sendOptions";
import { useDispatch, useSelector } from "react-redux";
import { getLinkInstallments } from "../../../common/helpers/installmentHelpers";
import { isCommissionSelectable } from "../../../common/helpers/isCommissionSelectable";
import { getParameters } from "../../../store/slices/parametersSlice";


export default function PaymentDetails({ setPaymentDetailsInfo, paymentDetailInfo, showParameters }) {


  const [bankInstallments, setBankInstallments] = useState(paymentDetailInfo.installments);
  const [isFetching, setIsFetching] = useState(false);
  const [vpList, setVpList] = useState([]);
  const [vpDetailsList, setVpDetailsList] = useState([]);
  const { parameters } = useSelector((state) => state.parameters);

  const loading = useLoading(isFetching);

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(getParameters());
  }, [])

  useEffect(() => {

    fetchData();
  }, []);
  useEffect(() => {

    if (vpDetailsList.length > 0) {
      updateInstallmentListByVP();
    }

  }, [vpDetailsList]);


  const fetchData = async () => {
    setIsFetching(true);

    const res = await commonNetwork.get("/virtualpos/firmvirtualpos-v1");
    const response = res;
    let vpTemp = [];
    if (response.isSuccess) {
      response.data.map((vp) => {
        if (vp.status) {
          vpTemp.push({
            value: vp.vpid,
            label: vp.vpdisplayname,
          });
        }
      });

      setVpList(vpTemp);
      setVpDetailsList(response.data);

      setIsFetching(false);
    } else {
      toast.error(response.errorMessage);
    }
  };


  const updateInstallmentListByVP = () => {
    let installmentList = [];

    if (paymentDetailInfo.vpId !== 0) {
      let vpDetail = vpDetailsList.find((item) => item.vpid === paymentDetailInfo.vpId);

      installmentList = getLinkInstallments(vpDetail.installmentListV1);


      setBankInstallments(installmentList);
    }
  };

  useEffect(() => {
    updateInstallmentListByVP();
  }, [paymentDetailInfo.vpId, vpDetailsList]);

  const updateFormInstallments = (month) => {
    let temp = paymentDetailInfo.installments;
    if (temp.includes(month)) {
      temp = temp.filter((i) => i !== month);
    } else {
      temp.push(month);
    }
    temp = Array.isArray(temp) ? temp : [temp];


    setPaymentDetailsInfo({
      ...paymentDetailInfo,
      installments: temp
    });
  };
  const onChangeParameter = (name, value) => {
    setPaymentDetailsInfo({
      ...paymentDetailInfo,
      [name]: value
    });
  }
  if (showParameters == false) {
    return;
  }

  return (
    <div className="w-full">
      <div className="w-full flex flex-col">
        <div className="ml-4 mr-4 p-4 bg-white shadow-md ">
          <div className="px-6 py-2">
            <div className="w-full text-ledt"> Link Gönderim Bilgileri</div>
            <div className="grid grid-cols-3 gap-3 ">
              <div className="mt-2">
                <Selector
                  options={paymentLinkDates}
                  name={`lastlinkdate`}
                  defaultValue={getExpireDateById(paymentDetailInfo.lastlinkdate || parameters.linkExpiryDate)}
                  className="w-[100%]"
                  label="Link Geçerlilik Süresi"
                  menuPortalTarget={document.body}
                  onChange={({ value }) => onChangeParameter("lastlinkdate", value)}
                  required
                />
              </div>
              <div className="mt-2">
                <Selector
                  options={sendOptions}
                  name={`sendtype`}
                  defaultValue={getSendOptionById(paymentDetailInfo.sendtype || parameters.sendTypeId)}
                  className="w-[100%]"
                  label="Link Gönderim Şekli"
                  menuPortalTarget={document.body}
                  onChange={({ value }) => onChangeParameter("sendtype", value)}
                  required
                />
              </div>
              <div className="mt-2">
                <Input
                  name={`linkdesc`}
                  defaultValue={paymentDetailInfo.linkdesc}
                  className="w-[100%]"
                  label="Link Açıklaması"

                  onChange={(ev) => {
                    onChangeParameter("linkdesc", ev.target.value)
                  }}
                />
              </div>
            </div>
            <div className={`grid grid-cols-1 gap-2 sm:gap-4 lg:grid-cols-3 xl:grid-cols-3  `}>
              <div className=" mt-10 ">

                <div className=" items-center flex flex-row">
                  <RadioButtons
                    items={[
                      { label: "Banka Seç", value: "manuel" },
                      { label: "Dinamik Yönlendirme", value: "dynamic" },
                    ]}
                    checked={paymentDetailInfo.paymentType}
                    onValueChange={(event) => {
                      setPaymentDetailsInfo({
                        ...paymentDetailInfo,
                        paymentType: event.target.value
                      });
                    }}
                    name="paymentType"
                  />
                </div>
              </div>
              <div className={paymentDetailInfo.paymentType === "manuel" ? " mt-3  " : "mt-10"}>
                {paymentDetailInfo.paymentType === "manuel" ? (
                  loading ? (
                    <div className="mt-4">Yükleniyor...</div>
                  ) : vpList.length > 0 ? (
                    <>
                      <Selector
                        options={vpList}
                        name="vpId"
                        label="Ödeme Altyapisi"
                        placeholder="Ödeme Altyapisi Seçiniz"
                        className="text-left"
                        onChange={(event) => {
                          setPaymentDetailsInfo({
                            ...paymentDetailInfo,
                            vpId: event.value
                          });
                        }}
                      // value={values.vpId}
                      />

                    </>
                  ) : (
                    <span className="text-base text-error text-base leading-5 ">
                      Aktif sanal POS listeniz veritabanindan okunamamistir.
                      Yetkili ile iletisime geciniz.
                    </span>
                  )
                ) : vpList.length > 0 ? (
                  <span className="text-base text-contrast-70 text-base leading-5" style={{ color: '#8D97A4' }}>
                    *Kredi kartına göre ilgili ödeme kuruluşuna otomatik yönlendirilir.
                  </span>
                ) : (
                  <span className="text-base text-error text-base leading-5" style={{ color: '#8D97A4' }}>
                    Aktif sanal POS listeniz veritabanindan okunamamistir.
                    Yetkili ile iletisime geciniz.
                  </span>
                )}
              </div>

              <div className=" mt-10  flex flex-row">
                <Checkbox
                  label={"Tutar Düzenlenebilsin mi?"}
                  name="isSyncOrders"
                  type="checkbox"
                  id="isSyncOrders"
                  onChange={(e) => {
                    setPaymentDetailsInfo({
                      ...paymentDetailInfo,
                      isEditableAmount: e.target.checked
                    });
                  }}
                  value={paymentDetailInfo.isEditableAmount}
                />
                {isCommissionSelectable() &&
                  <Checkbox
                    label={"Komisyon Uygulanmasın"}
                    name="isDisableCommission"
                    type="checkbox"
                    id="isDisableCommission"

                    className={"ml-4"}
                    onChange={(e) => {
                      setPaymentDetailsInfo({
                        ...paymentDetailInfo,
                        isDisableCommission: e.target.checked
                      });
                    }}
                    value={paymentDetailInfo.isDisableCommission}
                  />}
              </div>


            </div>
            {paymentDetailInfo.paymentType === "manuel" && vpList.length > 0 && paymentDetailInfo.vpId !== 0 && (
              <div className="p-4 mt-2 w-full">
                <InstallmentCheckBoxes
                  className="mt-3 grid grid-cols-2 gap-2 sm:gap-2 lg:grid-cols-3 xl:grid-cols-3"
                  installments={bankInstallments}
                  checkedlist={paymentDetailInfo.installments}
                  callback={(val) => {
                    updateFormInstallments(val);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
